import SiteLayout from "@/components/feature/SiteLayout";
import JsonLd from "@/components/feature/JsonLd";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faq";
import HeroSection from "./components/HeroSection";
import ScopesSection from "./components/ScopesSection";
import EventsSection from "./components/EventsSection";
import ResultsSection from "./components/ResultsSection";
import ProcessSection from "./components/ProcessSection";
import VoicesSection from "./components/VoicesSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "爆料直播",
  alternateName: "爆料直播官网",
  description: "直播争议举报与处理公示平台，提供直播举报通道、画面中断反馈、主播违规投诉与平台处理结果公示。",
  inLanguage: "zh-CN",
  about: ["爆料直播", "直播举报通道", "平台处理结果"],
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "爆料直播",
  description: "面向直播观众的争议举报与处理公示平台，提供直播争议事件全程跟踪与平台处理结果同步服务。",
  email: "feedback@baoliaolive.example",
  knowsAbout: ["直播举报通道", "画面中断反馈", "主播违规投诉", "直播争议事件", "平台处理结果"],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};

export default function Home() {
  usePageMeta({
    title: "爆料直播官网 - 直播举报通道与平台处理结果公示",
    description:
      "爆料直播官网提供直播举报通道与处理结果公示：画面中断可快速反馈，主播违规投诉直达平台，直播争议事件全程跟踪，平台处理结果第一时间同步。举报人信息严格保密，24 小时内受理，核查进度随时可查，处置结果公开可核。",
    keywords: "爆料直播,直播举报通道,画面中断反馈,主播违规投诉,直播争议事件,平台处理结果",
    path: "/",
  });

  return (
    <SiteLayout>
      <JsonLd id="ld-website" data={websiteSchema} />
      <JsonLd id="ld-organization" data={organizationSchema} />
      <JsonLd id="ld-faq" data={faqSchema} />
      <HeroSection />
      <ScopesSection />
      <EventsSection />
      <ResultsSection />
      <ProcessSection />
      <VoicesSection />
      <FaqSection />
      <CtaSection />
    </SiteLayout>
  );
}